export default "__VITE_ASSET__Ba_AHkTM__"